import axios from 'axios';

const rawEnvBase = import.meta.env.VITE_API_URL as string | undefined;
let API_BASE_URL = rawEnvBase || 'http://localhost:3004/api';
if (!API_BASE_URL.endsWith('/api')) {
  API_BASE_URL = API_BASE_URL.replace(/\/$/, '') + '/api';
}

/** Separate axios instance for backup page - no 401 redirect to /login */
export const backupApi = axios.create({
  baseURL: API_BASE_URL + '/backup',
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

export const backupAPI = {
  login: (email: string, password: string) =>
    backupApi.post('/login', { email, password }),

  logout: () => backupApi.post('/logout'),

  getList: () => backupApi.get('/list'),

  getDownloadUrl: (filename: string) => {
    const base = API_BASE_URL.replace(/\/api$/, '');
    return `${base}/api/backup/download/${encodeURIComponent(filename)}`;
  },
};
